<vue-server-messages [messages]="renderedMessages"></vue-server-messages>